module.exports = __webpack_public_path__ + "static/media/mytoken_user.d8e46656.png";